<template>
  <div
    class="audioModule"
    :class="{
      'minimal' : minimalInterface,
    }"
  >
    <div
      class="transitionWrapper"
      :class="{
        'minimal' : minimalInterface,
        'noScroll' : imageZoomed,
      }"
    >
      <div
        class="imgWrapper"
        :class="{
          'disabled' : !imagesAvailable,
          'isZoomed' : imageZoomed,
        }"
      >
        <InlineGallery
          :images="playerImages"
        />
      </div>
      <div class="sideWrapper">
        <div class="controlUnit">
          <div class="controlsWrapper">
            <AudioPlayer
              :class="{'disabled' : minimalInterface}"
              ref="audioPlayer"
            />
            <div class="controls">
              <div class="btnPlayPause">
                <div v-if="this.isLoading()">
                  <LoadSVG class="rotating"/>
                </div>
                <div v-else @click="this.togglePlayAudio">
                  <PauseSVG v-if="this.isPlaying()"/>
                  <PlaySVG v-else/>
                </div>
              </div>
              <div class="description" ref="playerDescription">
                <p>{{ audioAvailable ? this.currentPlayerDescription : '' }}</p>
                <p v-if="narratorAvailable">
                  {{ `Sprecher: ${this.currentPlayerAudio.narrator}` }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="textDisplay"
          :class="{'disabled' : !transcriptAvailable}"
        >
          <div v-if="transcriptAvailable">
            <h3>Transkript</h3>
            <p
              v-for="(entry, index) in currentPlayerAudio.transcript"
              :key="index"
            >{{ entry.paragraph }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadSVG from '../../../public/svg/load.svg';
import PlaySVG from '../../../public/svg/play.svg';
import PauseSVG from '../../../public/svg/pause.svg';
import AudioPlayer from './AudioPlayer.vue';
import InlineGallery from './InlineGallery.vue';

export default {
  name: 'audioModule',
  components: {
    InlineGallery,
    AudioPlayer,
    LoadSVG,
    PlaySVG,
    PauseSVG,
  },
  props: {
    minimalInterface: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters(['currentPlayerImages', 'currentPlayerAudio', 'currentPlayerDescription', 'playerAudioActive', 'imageZoomed']),
    audioAvailable() {
      return !(!this.currentPlayerAudio);
    },
    narratorAvailable() {
      return this.audioAvailable && !(!this.currentPlayerAudio.narrator);
    },
    transcriptAvailable() {
      return this.audioAvailable && !(!this.currentPlayerAudio.transcript);
    },
    imagesAvailable() {
      return !(!this.currentPlayerImages) && !(!this.currentPlayerImages[0]);
    },
    playerImages() {
      return (this.imagesAvailable
        ? this.currentPlayerImages
        : []);
    },
  },
  methods: {
    ...mapActions(['setPlayerGallery', 'setPlayerAudio', 'setPlayerAudioActive']),
    playAudio() {
      this.$refs.playerDescription.scrollTop = 0; // reset scrollposition for description
      this.$refs.audioPlayer.initAudio();
    },
    togglePlayAudio() {
      if (this.$refs.audioPlayer.isPlaying) {
        this.$refs.audioPlayer.stopAudio();
      } else {
        if (!this.playerAudioActive) {
          this.setPlayerAudioActive(true);
        }
        this.$refs.audioPlayer.playAudio();
      }
    },
    isPlaying() {
      if (!this.isMounted) { return false; }
      return this.$refs.audioPlayer.isPlaying;
    },
    isLoading() {
      if (!this.isMounted) { return false; }
      return this.$refs.audioPlayer.isLoading;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    playerAudioActive(newValue) {
      if (newValue && !this.$refs.audioPlayer.isPlaying) {
        if (process.env.VUE_APP_DEBUG === 'on') console.log('AudioModule PlayAudio');
        this.playAudio();
      }
      this.$el.scrollTop = 0;
    },
    imageZoomed(newValue) {
      if (newValue) {
        this.$el.scrollTop = 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.audioModule {
  position: relative;
  top: 14vh;
  top: calc(var(--vh, 1vh) * 14);
  width: 100vw;
  height: 86vh;
  height: calc(var(--vh, 1vh) * 86);
  overflow-y: scroll;
  /* pointer-events: none; */

  transform: translateX(0);
  transition: transform .0s;

  .transitionWrapper {
    width: 100vw;
    height: 86vh;
    height: calc(var(--vh, 1vh) * 86);
    overflow-y: scroll;
    transform: translateY(0);
    transition: transform .5s ease;

    &.noScroll {
      overflow: hidden;
    }
  }

  .imgWrapper {
    position: relative;
    /* position: absolute;
    top: 0; */
    width: 100vw;
    /* padding: 0 10vw; */
    padding: 0 10vw;
    padding-top: 4vh;
    padding-top: calc(var(--vh, 1vh) * 4);
    box-sizing: border-box;
    background-color: #eee;
    background-color: var(--main-background-color);
    /* pointer-events: all; */

    /* transform: translateY(0);
    transition: transform .5s ease; */

    &.isZoomed {
      height: 86vh;
      height: calc(var(--vh, 1vh) * 86);
      overflow: scroll;
    }

    &.disabled {
      height: 0;
      overflow: hidden;
    }
  }

  .sideWrapper{
    position: relative;
    /* position: absolute;
    top: 60vh;
    top: calc(var(--vh, 1vh) * 60); */
    padding-bottom: 10vh;
    padding-bottom: calc(var(--vh, 1vh) * 10);
    background-color: #eee;
    background-color: var(--main-background-color);
    pointer-events: all;

    /* transform: translateY(0);
    transition: transform .5s ease; */
  }

  .controlUnit {
    position: relative;
    width: 100vw;
    box-sizing: border-box;

    &.disabled {
      display: none;
    }
  }
  .textDisplay {
    padding: 0 10vw;

    &.disabled {
      display: none;
    }

    h3 {
      color: var(--main-elements-color);
    }
  }

  &.hidden {
    transform: translateX(100vw);
    transition-delay: .5s;

    .transitionWrapper {
      transform: translateY(85vh);
      transform: translateY(calc(var(--vh, 1vh) * 85));
    }
    /* .imgWrapper {
      transform: translateY(85vh);
      transform: translateY(calc(var(--vh, 1vh) * 85));
    }
    .sideWrapper{
      transform: translateY(35vh);
      transform: translateY(calc(var(--vh, 1vh) * 35))
    } */
  }

  .controlsWrapper {
    /* position: absolute;
    bottom: 0; */
    box-sizing: border-box;
    /* background-color: #eee;
    background-color: var(--main-background-color); */
    padding: 0 10vw;
    width: 100vw;
  }
  .controls {
    position: relative;
    width: 100%;
    min-height: 10vh;
    min-height: calc(var(--vh, 1vh) * 10);
    display: flex;

    .btnPlayPause {
      width: 40px;
      height: 40px;
      min-width: 30px;
      margin-left: -8px;
      margin-top: 1em;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 100%;
        height: 100%;
        fill: var(--main-elements-color);
      }
      .rotating {
        fill: var(--main-elements-color);
        animation: rotation 1s infinite linear;
      }
    }
    @keyframes rotation {
      from {transform: rotate(0deg);}
      to {transform: rotate(360deg);}
    }
    .description {
      flex: 2;
      margin-left: 20px;
      overflow-y: scroll;
      white-space: pre-line;
      /* padding-bottom: 1em; */

      p {
        margin: .6em 0;
        /* font-size: .9em; */
      }
    }
  }

  &.minimal {
    pointer-events: none;
    overflow: hidden;

    .imgWrapper {
      padding: 0;
    }
    .sideWrapper{
      top: 60vh;
      top: calc(var(--vh, 1vh) * 60);
      .controlUnit {
        .controlsWrapper {
          .controls {
            min-height: 10vh;
            min-height: calc(var(--vh, 1vh) * 10);
            max-height: 15vh;
            max-height: calc(var(--vh, 1vh) * 15);
          }
        }
      }
    }
  }
  &.minimal{
    &.hidden {
      .transitionWrapper {
        transform: translateY(35vh);
        transform: translateY(calc(var(--vh, 1vh) * 35));
      }
    }
  }
}
@media only screen and (min-width : 400px) {
  .audioModule {

    .imgWrapper,
    .controlsWrapper {
      padding-left: 40px;
      padding-right: 40px;
    }
    .textDisplay {
      padding: 0 40px;
      padding-bottom: 20vh;
      padding-bottom: calc(var(--vh, 1vh) * 20);
    }
  }
}
@media only screen and (orientation : landscape) {
  .audioModule {
    top: 14vh;
    top: calc(var(--vh, 1vh) * 14);
    height: 86vh;
    height: calc(var(--vh, 1vh) * 86);
    padding: 0;

    .transitionWrapper {
      display: flex;
      flex-direction: row;
      transform: translateY(0);
      transition: transform .5s ease;
      height: 86vh;
      height: calc(var(--vh, 1vh) * 86);
      overflow: hidden;
    }

    .imgWrapper {
      position: relative;
      flex: 2;
      padding: 0;
      order: 0;
      max-width: 38vw;

      &.isZoomed {
        max-width: none;
        width: 100vw;
        flex: none;
      }

      .playerImage {
        height: 77vh;
        height: calc(var(--vh, 1vh) * 77);
        margin: 0;
        background-size: 80vh;
        background-size: calc(var(--vh, 1vh) * 80);
      }
    }
    .sideWrapper{
      position: relative;
      top: 0;
      flex: 3;
      max-width: 62vw;
      height: 77vh;
      height: calc(var(--vh, 1vh) * 86);
      overflow-y: scroll;

      .controlUnit {
        position: relative;
        top: 0;
        padding-top: 5vh;
        padding-top: calc(var(--vh, 1vh) * 5);
        overflow-y: scroll;
        padding: 0;
        background-color: #eee;
        background-color: var(--main-background-color);
        width: auto;

        .controlsWrapper {
          position: relative;
          width: auto;

          .controls {
          }
        }
      }
      .textDisplay {
        position: relative;
        top: 0;
      }
    }
    &.minimal {
      height: 86vh;
      height: calc(var(--vh, 1vh) * 86);

      .sideWrapper{
        position: absolute;
        right: 0;
        top: 0;
        width: 38vw;
        height: 86vh;
        height: calc(var(--vh, 1vh) * 86);
        padding: 0;

        .controlUnit {
          height: 86vh;
          height: calc(var(--vh, 1vh) * 86);
          .controlsWrapper {
            position: absolute;
            bottom: 10vh;
            bottom: calc(var(--vh, 1vh) * 10);
            .controls {
              min-height: none;
              max-height: 76vh;
              max-height: calc(var(--vh, 1vh) * 76);
            }
          }
        }
      }
      &.hidden {
        .transitionWrapper {
          transform: translateY(86vh);
          transform: translateY(calc(var(--vh, 1vh) * 86));
        }
      }
    }
  }
  @media only screen and (min-aspect-ratio: 3/2) { // and (max-width : 900px)
    .audioModule {
      &.minimal {
        .sideWrapper{
          max-width: none;
          width: 62vw;
        }
      }
    }
  }
}
</style>
